import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login.component';
import { LayoutComponent } from './shared/components/layout.component';
import { authGuard } from './core/guards/auth.guard';
import { UserListComponent } from './features/users/user-list.component';
import { UserCreateComponent } from './features/users/user-create.component';
import { UserEditComponent } from './features/users/user-edit.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { SousTraitantListComponent } from './features/sous-traitants/list/sous-traitant-list.component';
import { SousTraitantCreateComponent } from './features/sous-traitants/create/sous-traitant-create.component';
import { SousTraitantEditComponent } from './features/sous-traitants/edit/sous-traitant-edit.component';
import { ProjectListComponent } from './features/projects/list/project-list.component';
import { ProjectEditComponent } from './features/projects/edit/project-edit.component';
import { DocTypeVersionComponent } from './features/settings/doc-type-version/doc-type-version.component';
import { ClientEditComponent } from './features/clients/edit/client-edit.component';
import { ClientListComponent } from './features/clients/list/client-list.component';
import { ClientCreateComponent } from './features/clients/create/client-create.component';
import { ContactListComponent } from './features/contacts/list/contact-list.component';
import { ContactCreateComponent } from './features/contacts/create/contact-create.component';
import { ContactEditComponent } from './features/contacts/edit/contact-edit.component';
import { TemplateFatComponent } from './features/template-fat/template-fat.component';
import { AffaireListComponent } from './features/affaires/list/affaire-list.component';
import { AffaireCreateComponent } from './features/affaires/create/affaire-create.component';
import { AffaireEditComponent } from './features/affaires/edit/affaire-edit.component';
import { FatPageComponent } from './features/projects/fat/fat-page.component';
import { ComptageRuleListComponent } from './features/settings/metering/list/comptage-rule-list.component';
import { StatusListComponent } from './features/settings/status/list/status-list.component';
import { TeamListComponent } from './features/settings/team/list/team-list.component';
import { WorkflowListComponent } from './features/settings/workflow/list/workflow-list.component';
import { WorkflowFormComponent } from './features/settings/workflow/form/workflow-form.component';
import { RoleListComponent } from './features/settings/role/list/role-list.component';

import { FatListComponent } from './features/fats/list/fat-list.component';

import { ForbiddenComponent } from './shared/components/forbidden.component';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'projects', component: ProjectListComponent },
      { path: 'projects/edit/:id', component: ProjectEditComponent },
      { path: 'fats', component: FatListComponent },
      {
        path: 'settings/doc-types',
        component: DocTypeVersionComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/comptage-rules',
        component: ComptageRuleListComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/statuses',
        component: StatusListComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/teams',
        component: TeamListComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/workflows/new',
        component: WorkflowFormComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/workflows/edit/:id',
        component: WorkflowFormComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/workflows',
        component: WorkflowListComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'settings/roles',
        component: RoleListComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'clients',
        component: ClientListComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'clients/new',
        component: ClientCreateComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'clients/edit/:id',
        component: ClientEditComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'contacts',
        component: ContactListComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'contacts/new',
        component: ContactCreateComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'contacts/edit/:id',
        component: ContactEditComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'sous-traitants',
        component: SousTraitantListComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'sous-traitants/new',
        component: SousTraitantCreateComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'sous-traitants/edit/:id',
        component: SousTraitantEditComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'users',
        component: UserListComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'users/new',
        component: UserCreateComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'users/edit/:id',
        component: UserEditComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'template-fat',
        component: TemplateFatComponent,
        canActivate: [roleGuard]
      },
      {
        path: 'affaires',
        component: AffaireListComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'affaires/new',
        component: AffaireCreateComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      {
        path: 'affaires/edit/:id',
        component: AffaireEditComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['ROLE_RESP_AFFAIRE'] }
      },
      { path: 'projects/:projectId/fats/:fatId', component: FatPageComponent },
      { path: 'forbidden', component: ForbiddenComponent },
    ]
  },
  { path: '**', redirectTo: '' }
];
